module.exports = __webpack_public_path__ + "static/media/2-about.b6a23c9d.jpg";